<template>
  <el-dialog 
    title="数据填充" 
    :visible.sync="dialogVisible" 
    width="50%" 
    :before-close="handleClose"
  >
    <el-table :data="paddingTableData" border style="width: 100%">
      <el-table-column label="日期" align="center">
        <template slot-scope="scope">{{timestampToTime(scope.row.createTime)}}</template>
      </el-table-column>
      <el-table-column label="芯城" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.createSpecData[0].xkMallName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="芯品" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.createSpecData[0].xkProjectName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" :label="this.$t('title.operate')" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="echoData(scope.row)">填充</el-button>
          <!-- <span  style="display:inline-block;margin-left:10px;">下载</span> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="echoPageChange"
      :current-page="echoPage"
      :page-size="echoPageNum"
      layout="total,prev, pager, next"
      :total="echoTotal"
    ></el-pagination>
  </el-dialog>
</template>
<script>
import {
  getStrategyShow,
  getExample
} from "@/api/interface";
export default {
  props: ['PropdialogVisible', 'environment'],
  data() {
    return {
      paddingTableData: [],
      echoPageNum: 5,
      echoPage: 1,
      echoTotal: 0,
      dialogVisible: false,
    }
  },
  watch: {
    PropdialogVisible(val) {
      this.dialogVisible = val
      this.getStrategyShows(this.echoPageNum, this.echoPage);
    }
  },
  created() {
    this.getStrategyShows(this.echoPageNum, this.echoPage);
  },
  methods: {
           //获取报表数据
    getStrategyShows(pageNum, page) {
      const data = {
        pageNum,
        page
      };
      getExample(data, this.environment.http).then(res => {
        console.log(res, 900000)
        const data = JSON.parse(res.data);
        console.log(data, 100000)
        this.total = data.total;
        this.echoTotal = data.total;
        this.tableData = data.strategyList;
        this.paddingTableData = this.tableData.map(v => {
          v.createSpecData = JSON.parse(v.createSpecData);
          v.createUserData = JSON.parse(v.createUserData);
          v.createXcXpData = JSON.parse(v.createXcXpData);
          return v;
        });
      });
    },
     //回显数据
    echoData(row) {
      const createXcXpData = row.createXcXpData
      const sizeData = row.createSpecData.map(v => ({
        ...v,
        pingtaiState: v.pingtaiState == 0 ? false : true,
        supplyPrice: v.supplyPrice / 100,
        retailPrice: v.retailPrice / 100,
        automaticRebate: v.automaticRebate / 100,
        shareRebate: v.shareRebate / 100
      }));
      const regData = row.createUserData.map(v => ({
        ...v,
        xk: v.xk == 0 ? false : true,
        mall: v.mall == 0 ? false : true
      }));
      // this.xinChengs = row.createXcXpData;
      // this.sizeData = sizeData;
      // this.regData = regData;
      this.dialogVisible = false;
       this.$emit('handleClose', false)
      this.$emit('echoData', { createXcXpData, sizeData, regData })
      this.$message.success("填充成功!");
    },  
    //填充分页
    echoPageChange(e) {
      this.echoPage = e;
      console.log(e, 9999);
      this.getStrategyShows(this.echoPageNum, this.echoPage);
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('handleClose', false)
    }
  }
}
</script>
<style scoped lang="scss">
.el-pagination {
    float: none;
    margin-right: 0;
    margin-bottom: 0;
  }
</style>